module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"jwt":"(secured with JWT)"}}')
  delete Component.options._Ctor
}
